import React, { createContext, useContext, useMemo, useState } from "react";
import apiFetch from "../utils/apiFetch";

// Single source of truth for the staff's dashboard bookmarks, shared by the
// Dashboard Menu (which edits them) and the Home screen (which displays them),
// so a change in one re-renders the other without a page reload. Seeded once
// from the server-rendered appProps; local state is authoritative thereafter.
const BookmarksContext = createContext({
  bookmarkIds: [],
  setBookmarkIds: () => {},
  persistBookmarks: () => Promise.resolve(),
});

export function BookmarksProvider({ initial = [], children }) {
  const [bookmarkIds, setBookmarkIds] = useState(initial);

  const value = useMemo(
    () => ({
      bookmarkIds,
      setBookmarkIds,
      // Fire-and-forget save; callers update local state optimistically.
      persistBookmarks: (ids) =>
        apiFetch("/api/staff_preference", {
          method: "PATCH",
          body: JSON.stringify({ staff_preference: { bookmarks: ids } }),
        }).catch(() => {}),
    }),
    [bookmarkIds]
  );

  return (
    <BookmarksContext.Provider value={value}>
      {children}
    </BookmarksContext.Provider>
  );
}

export function useBookmarks() {
  return useContext(BookmarksContext);
}
